<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-md-offset-1">
        <div class="card card-wizard" id="wizardCard">

          <form-wizard ref="wizard" error-color="#EB5E28" color="#1e94fd" title="Ingresos" subtitle="" @on-complete="siguente">
            <tab-content v-if="this.getKey('tipo_dec') === 'Inicial'" :before-change="saveIngresos" lazy title="Ingresos netos del declarante, pareja y/o dependientes económicos (situación actual)" icon="ti-user">
              <sueldos-salarios ref="SueldosSalarios"></sueldos-salarios>
            </tab-content>
            <!-- Situación patrimonial a la fecha de baja -->
            <tab-content :before-change="saveSalarios" :title="situacion" lazy icon="ti-user">
              <sueldos-salarios-otros ref="SueldosSalariosOtros"></sueldos-salarios-otros>
            </tab-content>
            <tab-content :before-change="saveSalariosFinales" title="Situación patrimonial en el año inmediato anterior." lazy icon="ti-user" v-if="this.getKey('tipo_dec_usuario') === 3">
              <finales ref="IngresosFinales"></finales>
            </tab-content>
            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Atrás</button>
            <button slot="next" class="btn btn-info btn-fill btn-wd btn-next">Siguiente</button>
            <button slot="finish" class="btn btn-info btn-fill btn-wd btn-next">Siguientes</button>
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  FormWizard,
  TabContent
} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import SueldosSalarios from './Formularios/Ingresos/SueldosSalarios.vue'
import SueldosSalariosOtros from './Formularios/Ingresos/SueldosSalariosOtros.vue'
import ActividadProfesional from './Formularios/Ingresos/ActividadProfesional.vue'
import ActividadEmpresarial from './Formularios/Ingresos/ActividadEmpresarial.vue'
import ActividadEconomica from './Formularios/Ingresos/ActividadEconomica.vue'
import Arrendamiento from './Formularios/Ingresos/Arrendamiento.vue'
import Intereses from './Formularios/Ingresos/Intereses.vue'
import Premios from './Formularios/Ingresos/Premios.vue'
import Enajenacion from './Formularios/Ingresos/Enajenacion.vue'
import OtrosIngresos from './Formularios/Ingresos/OtrosIngresos.vue'
import Finales from './Formularios/Ingresos/IngresosFinales.vue'
import swal from 'sweetalert2'
export default {
  data () {
    return {
      wizardModel: {},
      situacion: 'Situación patrimonial año anterior'
      // grupo: null

    }
  },
  components: {
    FormWizard,
    TabContent,
    SueldosSalarios,
    SueldosSalariosOtros,
    ActividadProfesional,
    ActividadEmpresarial,
    ActividadEconomica,
    Arrendamiento,
    Intereses,
    Premios,
    Enajenacion,
    OtrosIngresos,
    Finales
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions () {
      if (!(this.getKey('role') == 0 && this.getKey('status_dec') == 1)) {
        localStorage.clear()
        this.$router.push('/login')
        this.$router.go()
      }
    },
    saveIngresos () {
      return new Promise((resolve, reject) => {
        // this.$validator.validateAll().then(response => {
        // this.$refs.DatosPersonales.validateAll().then(response => {
        this.$refs.SueldosSalarios.valida().then(response => {
          // this.$refs.SueldosSalarios.item_entes
          this.item_entes = this.$refs.SueldosSalarios.item_entes
          console.log(response)
          if (response) {
            this.item_entes.ip_id = this.ip_id
            this.loadButton(this.$refs.btnSave)
            this.$http.post('sueldos_publicos', this.item_entes).then(
              response => {
                this.StepOk('Guardado')
                // if (this.edit_item === undefined || this.edit_item === null) {
                // this.item_entes = data.response.sueldos
                // }
                // this.showItem()
                // this.initItem()
                //  this.edit_item = null
                return resolve(true) // después de enviar, deja continuar
              },
              error => {
                this.StepW(error)
                // this.change =  true;
              }
            )
          } else { return resolve(false) }
        })
      })
    },
    saveSalarios () {
      this.item_entes22 = this.$refs.SueldosSalariosOtros.item_entes22
      var v = this
      return new Promise((resolve, reject) => {
        // el tab wizard necesita que se regrese una promesa para dejar continuar
        this.$refs.SueldosSalariosOtros.validate().then(
          response => {
            if (response) {
              this.item_entes22.ip_id = this.ip_id
              /* this.loadButton(this.$refs.btnSave); */
              this.$http.post('sueldos_otros', this.item_entes22).then(
                response => {
                  // console.log(response)
                  this.StepOk('Guardado')

                  return resolve(true) // después de enviar, deja continuar
                },
                error => {
                  this.StepW(error)
                }
              )
            } else {
              this.StepW('Hay campos sin completar')
              return reject(false)
            }
          }).catch(e => {
            reject(false)
          })
      })
      // console.log(this.item_entes22);
    },
    saveSalariosFinales () {
      this.ingresos_finales = this.$refs.IngresosFinales.ingresos_finales

      return new Promise((resolve, reject) => {
        if (this.ingresos_finales.bandera == '0') {
          // Borrar
          if (this.ingresos_finales.id) {
            this.ingresos_finales.ip_id = this.ip_id
            this.$http.delete('ingresos_finales/' + this.ingresos_finales.id).then(
              response => {
                this.StepOk('Guardado')
                return resolve(true) // después de enviar, deja continuar
              },
              error => {
                this.StepW(error)
                reject(false)
              })
          } else {
            return resolve(true)
          }
        } else {
          // el tab wizard necesita que se regrese una promesa para dejar continuar
          this.$refs.IngresosFinales.validate().then(
            response => {
              if (response) {
                this.ingresos_finales.ip_id = this.ip_id
                this.$http.post('ingresos_finales', this.ingresos_finales).then(
                  response => {
                    this.StepOk('Guardado')
                    return resolve(true) // después de enviar, deja continuar
                  },
                  error => {
                    this.StepW(error)
                  }
                )
              } else {
                this.StepW('Hay campos sin completar')
                return reject(false)
              }
            }).catch(e => {
              reject(false)
            })
        }
      })
    },

    siguente () {
      var simplificada = this.getKey('simplificada')
      if (simplificada == '1') {
        this.$router.push('fiscal')
      } else {
        this.$router.push('activos')
      }

      // if (this.grupo != 3) {

      // } else {
      //   this.$router.push('resumen');

      // }
    },
    validateFirstStep () {
      return this.$refs.firstStep.validate()
    },
    validateSecondStep () {
      return this.$refs.secondStep.validate()
    },
    wizardComplete () {
      // we gather models from all steps into one model
      this.wizardModel = {
        ...this.$refs.datosPersonales.model,
        ...this.$refs.firstStep.model,
        ...this.$refs.DatosCurriculares.model,
        ...this.$refs.DatosConyuge.model,
        ...this.$refs.secondStep.model
      }
      this.$swal('Good job!', 'You clicked the finish button!', 'success')
    }
  },
  created () {
    this.checkPermissions()

    if (this.getKey('tipo_dec_usuario') === 3) {
      this.situacion = 'Situación patrimonial a la fecha de baja'
    }
    // "this.getKey('tipo_dec_usuario') === 3"
    // this.grupo = this.getKey('grupo')
  },
  mounted () {
    this.$refs.wizard.activateAll()
  }
}

</script>
<style>
.vue-form-wizard .wizard-icon-circle.tab_shape {
  background-color: #9A9A9A !important;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Ingresos.vue